<template>
  <div>
    <div class="dropzone" @click="clearDropzone" ref="dropzone"></div>
    <script type="text/x-template" id="dropzone-preview-template" ref="template">
      <div class="dz-preview dz-file-preview">
        <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
      </div>
    </script>
  </div>
</template>

<script>
  let Dropzone = require('dropzone');
  Dropzone.autoDiscover = false;

  export default {
    props: ['defaultMessage', 'maxFilesize', 'acceptedFiles'],
    data() {
      return {
        dropzone: false,
      }
    },
    mounted() {
      let vm = this;
      vm.dropzone = new Dropzone(vm.$refs.dropzone, {
        acceptedFiles: vm.acceptedFiles ? vm.acceptedFiles : '.jpg,.png,.gif',
        previewTemplate: vm.$refs.template.innerHTML,
        url: '/api/upload/image',
        headers: {
          'X-XSRF-TOKEN': Cookies.get('XSRF-TOKEN'),
          'X-Requested-With': 'XMLHttpRequest'
        },
        dictDefaultMessage: vm.defaultMessage ? vm.defaultMessage : vm.$t('dropzone_component.default_message'),
        maxFilesize: vm.maxFilesize ? vm.maxFilesize : 10, // MB
        success: (response, obj) => {
          vm.$emit('upload', obj);
        },
        error: (obj, msg) => {
          (new Notyf()).alert(msg);
          vm.clearDropzone();
        }
      });
    },
    methods: {
      clearDropzone() {
        this.dropzone.removeAllFiles(true);
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";
  .dropzone {
    .dz-error { border: 2px solid red; }
    .dz-error-message {
      opacity: 1;
    }
  }
</style>

<style lang="scss">
  .dz-error-message {
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// dropzone.vue?a69a147c